var render = function render(){var _vm=this,_c=_vm._self._c;return _c('urgent-notification-other-type-action',{attrs:{"data":_vm.data},on:{"close":(x) => _vm.$emit('close', x)}})
}
var staticRenderFns = []

export { render, staticRenderFns }